import { ChipProps } from '@mui/material';

import {
  SubjectColors,
  SUBJECT_COLORS_DIVIDED,
  SUBJECT_COLORS_NEW,
  GRADIENT_COLORS,
  TP_COLORS,
} from '../constants';
import { IQuestion } from '../store/QuestionSlice';

const getNumberHashFromString = (text: string): number => {
  const _stringToBeHashed: string = text ? text.trim() : 'no-subject';
  let hash = 0;
  if (_stringToBeHashed.length === 0) return hash;
  for (let i = 0; i < _stringToBeHashed.length; i += 1) {
    const charCode = _stringToBeHashed.charCodeAt(i);
    // eslint-disable-next-line no-bitwise
    hash = (hash << 7) - hash + charCode;
    hash = hash && hash;
  }
  return hash;
};

export const getSubjectColor = (subject: string): string => {
  const numberHash: number = getNumberHashFromString(subject);
  const absoluteNumberHash = Math.abs(numberHash);
  const index = absoluteNumberHash % SubjectColors.length;
  const color: string = SubjectColors[index];
  return color;
};

export const getQuestionDifficultyChipColor = (
  difficulty: IQuestion['difficulty']
): ChipProps['color'] => {
  let color: ChipProps['color'] = 'default';
  switch (difficulty) {
    case 'EASY':
      color = 'success';
      break;
    case 'MEDIUM':
      color = 'warning';
      break;
    case 'HARD':
      color = 'error';
      break;
    default:
      color = 'default';
      break;
  }
  return color;
};

export const getDividedSubjectColors = (
  subject: string
): { color1: string; color2: string } => {
  const numberHash: number = getNumberHashFromString(subject);
  const absoluteNumberHash = Math.abs(numberHash);
  const index = absoluteNumberHash % SUBJECT_COLORS_DIVIDED.length;
  return SUBJECT_COLORS_DIVIDED[index];
};

export const getSubjectColorNew = (subject: string): string => {
  switch (subject) {
    case 'Mathematics':
    case 'MathematicsNew':
      return SUBJECT_COLORS_NEW.Mathematics;
    case 'Biology':
    case 'Biology A (Salters-Nuffield)':
    case 'Biology B':
      return SUBJECT_COLORS_NEW.Biology;
    case 'Chemistry':
      return SUBJECT_COLORS_NEW.Chemistry;
    case 'Physics':
      return SUBJECT_COLORS_NEW.Physics;
    case 'Coordinated Science':
      return SUBJECT_COLORS_NEW.CoordinatedScience;
    case 'Economics':
      return SUBJECT_COLORS_NEW.Economics;
    case 'Business Studies':
      return SUBJECT_COLORS_NEW.BusinessStudies;
    case 'English Language':
      return SUBJECT_COLORS_NEW.EnglishLanguage;
    case 'English Literature':
      return SUBJECT_COLORS_NEW.EnglishLiterature;
    case 'Additional Mathematics':
      return SUBJECT_COLORS_NEW.AdditionalMathematics;
    case 'Computer Science':
      return SUBJECT_COLORS_NEW.ComputerScience;
    case 'Combined Science':
      return SUBJECT_COLORS_NEW.CombinedScience;
    case 'Science':
      return SUBJECT_COLORS_NEW.Science;
    case 'Chinese':
      return SUBJECT_COLORS_NEW.Chinese;
    default:
      return SUBJECT_COLORS_NEW.Other;
  }
};

export const typoGradientStyles = {
  background: GRADIENT_COLORS.color1,
  backgroundClip: 'text',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
};

export const getDifficultyColor = (difficulty: string): string => {
  switch (difficulty) {
    case 'EASY':
      return TP_COLORS.green.light;
    case 'MEDIUM':
      return TP_COLORS.yellow.light;
    case 'HARD':
      return TP_COLORS.orange.light;
    default:
      return TP_COLORS.gray.light;
  }
};
